function normalizePathname(pathname: string) {
  return pathname.replace(/\/$/, '') || '/'
}

export const isCurrentLink = (options: {url: string; actual?: string}) => {
  if (options.actual === undefined) {
    return false
  }

  const url = new URL(options.url, undefined)
  const actual = new URL(options.actual, undefined)

  const isSameHost = url.hostname === actual.hostname
  const isSamePath = normalizePathname(url.pathname) === normalizePathname(actual.pathname)

  return isSameHost && isSamePath
}
